import { createTheme } from '@mui/material/styles';

const DefaultTheme = createTheme({
  palette: {
    primary: {
      dark: '#0288D1',
      main: '#03A9F4',
      light: '#B3E5FC',
      contrastText: '#FFFFFF',
    },
    secondary: {
      dark: '#00796B',
      main: '#009688',
      light: '#B2DFDB',
      contrastText: '#FFFFFF',
    },
    accent: '#448AFF',
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
    off: {
      main: '#FF0000',
      contrastText: '#F2FF00',
    },
    on: {
      main: '#00FF19',
      contrastText: '#0055FF',
    },
    toggle: {
      main: '#03A9F4',
      contrastText: '#FFFFFF',
    },
    disabled: {
      main: '#757575',
      contrastText: '#212121',
    },
    divider: '#BDBDBD',
    successful: '#4caf50',
    warn: '#e9a83f',
  },
});

export default DefaultTheme;